import has from 'lodash/has';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import mapValues from 'lodash/mapValues';
import moment from 'moment/moment';

/**
 * @param {TodoMessage} message
 * @return {Boolean}
 */
export function actionIsSelected(message) {
  return !!message.selectedAction;
}

export function translateMessages(item, $translate, logger) {
  const nextItem = {
    ...item,
  };
  const params = buildMessageParams({
    ...item.data,
    feedable: item.feedable,
    feedTarget: item.feedTarget,
  }, $translate, logger);

  nextItem.message = $translate.instant(item.msg, params);

  nextItem.actions = mapValues(item.actions, action => ({
    ...action,
    message: $translate.instant(action.msg),
    selectedMessage: $translate.instant(action.selectedMsg, params),
  }));

  return nextItem;
}

export function buildMessageParams(data, $translate, logger) {
  return mapValues(data, (entry, key) => {
    if (isObject(entry)) {
      if (entry.hasOwnProperty('date')) {
        return moment(entry.date).format(entry.time ? 'lll' : 'll');

      } else if (isString(entry.msg)) {
        return $translate.instant(entry.msg, entry.data);

      } else if (has(entry, 'value')) {
        return entry.value;

      } else {
        // TODO: we could also check if the entry with id,collection pair but no value and report that as a more specific error
        logger.warn({entry}, `Unsupported activity feed data property '${key}' with value ${JSON.stringify(entry)}`);
        return '?';

      }
    } else {
      return entry;
    }
  });
}



// WEBPACK FOOTER //
// ./src/js/todo-messages/utils/index.js